"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameFormat = exports.DateFormat = void 0;
var DateFormat;
(function (DateFormat) {
    DateFormat["DEFAULT"] = "D/M/YYYY";
    DateFormat["JP"] = "YYYY\u5E74M\u6708D\u65E5";
})(DateFormat = exports.DateFormat || (exports.DateFormat = {}));
var NameFormat;
(function (NameFormat) {
    NameFormat["DEFAULT"] = "<firstName> <lastName>";
    NameFormat["JP"] = "<lastName> <firstName>";
})(NameFormat = exports.NameFormat || (exports.NameFormat = {}));
//# sourceMappingURL=types.js.map